import _slicedToArray from "/var/jenkins_home/workspace/Dimas Constru\xE7\xF5es DVERT LP/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _get from "/var/jenkins_home/workspace/Dimas Constru\xE7\xF5es DVERT LP/node_modules/@babel/runtime/helpers/esm/get.js";
import _assertThisInitialized from "/var/jenkins_home/workspace/Dimas Constru\xE7\xF5es DVERT LP/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/var/jenkins_home/workspace/Dimas Constru\xE7\xF5es DVERT LP/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/var/jenkins_home/workspace/Dimas Constru\xE7\xF5es DVERT LP/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/var/jenkins_home/workspace/Dimas Constru\xE7\xF5es DVERT LP/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _classCallCheck from "/var/jenkins_home/workspace/Dimas Constru\xE7\xF5es DVERT LP/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/jenkins_home/workspace/Dimas Constru\xE7\xF5es DVERT LP/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/var/jenkins_home/workspace/Dimas Constru\xE7\xF5es DVERT LP/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { defineHidden as B } from "@react-spring/shared";
var h = Symbol.for("Animated:node"),
  v = function v(e) {
    return !!e && e[h] === e;
  },
  k = function k(e) {
    return e && e[h];
  },
  D = function D(e, t) {
    return B(e, h, t);
  },
  F = function F(e) {
    return e && e[h] && e[h].getPayload();
  },
  c = /*#__PURE__*/function () {
    function c() {
      _classCallCheck(this, c);
      _defineProperty(this, "payload", void 0);
      D(this, this);
    }
    _createClass(c, [{
      key: "getPayload",
      value: function getPayload() {
        return this.payload || [];
      }
    }]);
    return c;
  }();
import { is as A } from "@react-spring/shared";
var l = /*#__PURE__*/function (_c) {
  _inherits(l, _c);
  var _super = _createSuper(l);
  function l(r) {
    var _this;
    _classCallCheck(this, l);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized(_this), "done", !0);
    _defineProperty(_assertThisInitialized(_this), "elapsedTime", void 0);
    _defineProperty(_assertThisInitialized(_this), "lastPosition", void 0);
    _defineProperty(_assertThisInitialized(_this), "lastVelocity", void 0);
    _defineProperty(_assertThisInitialized(_this), "v0", void 0);
    _defineProperty(_assertThisInitialized(_this), "durationProgress", 0);
    _this._value = r;
    A.num(_this._value) && (_this.lastPosition = _this._value);
    return _this;
  }
  _createClass(l, [{
    key: "getPayload",
    value: function getPayload() {
      return [this];
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this._value;
    }
  }, {
    key: "setValue",
    value: function setValue(r, n) {
      return A.num(r) && (this.lastPosition = r, n && (r = Math.round(r / n) * n, this.done && (this.lastPosition = r))), this._value === r ? !1 : (this._value = r, !0);
    }
  }, {
    key: "reset",
    value: function reset() {
      var r = this.done;
      this.done = !1, A.num(this._value) && (this.elapsedTime = 0, this.durationProgress = 0, this.lastPosition = this._value, r && (this.lastVelocity = null), this.v0 = null);
    }
  }], [{
    key: "create",
    value: function create(r) {
      return new l(r);
    }
  }]);
  return l;
}(c);
import { is as K, createInterpolator as R } from "@react-spring/shared";
var d = /*#__PURE__*/function (_l) {
  _inherits(d, _l);
  var _super2 = _createSuper(d);
  function d(t) {
    var _this2;
    _classCallCheck(this, d);
    (_this2 = _super2.call(this, 0), _defineProperty(_assertThisInitialized(_this2), "_string", null), _defineProperty(_assertThisInitialized(_this2), "_toString", void 0)), _this2._toString = R({
      output: [t, t]
    });
    return _this2;
  }
  _createClass(d, [{
    key: "getValue",
    value: function getValue() {
      var t = this._string;
      return t !== null && t !== void 0 ? t : this._string = this._toString(this._value);
    }
  }, {
    key: "setValue",
    value: function setValue(t) {
      if (K.str(t)) {
        if (t == this._string) return !1;
        this._string = t, this._value = 1;
      } else if (_get(_getPrototypeOf(d.prototype), "setValue", this).call(this, t)) this._string = null;else return !1;
      return !0;
    }
  }, {
    key: "reset",
    value: function reset(t) {
      t && (this._toString = R({
        output: [this.getValue(), t]
      })), this._value = 0, _get(_getPrototypeOf(d.prototype), "reset", this).call(this);
    }
  }], [{
    key: "create",
    value: function create(t) {
      return new d(t);
    }
  }]);
  return d;
}(l);
import { isAnimatedString as q } from "@react-spring/shared";
import { each as L, eachProp as w, getFluidValue as M, hasFluidValue as C } from "@react-spring/shared";
var f = {
  dependencies: null
};
var u = /*#__PURE__*/function (_c2) {
  _inherits(u, _c2);
  var _super3 = _createSuper(u);
  function u(r) {
    var _this3;
    _classCallCheck(this, u);
    _this3 = _super3.call(this);
    _this3.source = r;
    _this3.setValue(r);
    return _this3;
  }
  _createClass(u, [{
    key: "getValue",
    value: function getValue(r) {
      var n = {};
      return w(this.source, function (a, i) {
        v(a) ? n[i] = a.getValue(r) : C(a) ? n[i] = M(a) : r || (n[i] = a);
      }), n;
    }
  }, {
    key: "setValue",
    value: function setValue(r) {
      this.source = r, this.payload = this._makePayload(r);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.payload && L(this.payload, function (r) {
        return r.reset();
      });
    }
  }, {
    key: "_makePayload",
    value: function _makePayload(r) {
      if (r) {
        var n = new Set();
        return w(r, this._addToPayload, n), Array.from(n);
      }
    }
  }, {
    key: "_addToPayload",
    value: function _addToPayload(r) {
      var _this4 = this;
      f.dependencies && C(r) && f.dependencies.add(r);
      var n = F(r);
      n && L(n, function (a) {
        return _this4.add(a);
      });
    }
  }]);
  return u;
}(c);
var y = /*#__PURE__*/function (_u) {
  _inherits(y, _u);
  var _super4 = _createSuper(y);
  function y(t) {
    _classCallCheck(this, y);
    return _super4.call(this, t);
  }
  _createClass(y, [{
    key: "getValue",
    value: function getValue() {
      return this.source.map(function (t) {
        return t.getValue();
      });
    }
  }, {
    key: "setValue",
    value: function setValue(t) {
      var r = this.getPayload();
      return t.length == r.length ? r.map(function (n, a) {
        return n.setValue(t[a]);
      }).some(Boolean) : (_get(_getPrototypeOf(y.prototype), "setValue", this).call(this, t.map(z)), !0);
    }
  }], [{
    key: "create",
    value: function create(t) {
      return new y(t);
    }
  }]);
  return y;
}(u);
function z(e) {
  return (q(e) ? d : l).create(e);
}
import { is as G, isAnimatedString as J } from "@react-spring/shared";
function Le(e) {
  var t = k(e);
  return t ? t.constructor : G.arr(e) ? y : J(e) ? d : l;
}
import { is as g, eachProp as oe } from "@react-spring/shared";
import * as O from "react";
import { forwardRef as Q, useRef as H, useCallback as X, useEffect as Y } from "react";
import { is as N, each as V, raf as U, useForceUpdate as Z, useOnce as ee, addFluidObserver as te, removeFluidObserver as E, useIsomorphicLayoutEffect as re } from "@react-spring/shared";
var x = function x(e, t) {
    var r = !N.fun(e) || e.prototype && e.prototype.isReactComponent;
    return Q(function (n, a) {
      var i = H(null),
        o = r && X(function (s) {
          i.current = ae(a, s);
        }, [a]),
        _ne = ne(n, t),
        _ne2 = _slicedToArray(_ne, 2),
        m = _ne2[0],
        T = _ne2[1],
        W = Z(),
        P = function P() {
          var s = i.current;
          if (r && !s) return;
          (s ? t.applyAnimatedValues(s, m.getValue(!0)) : !1) === !1 && W();
        },
        _ = new b(P, T),
        p = H();
      re(function () {
        return p.current = _, V(T, function (s) {
          return te(s, _);
        }), function () {
          p.current && (V(p.current.deps, function (s) {
            return E(s, p.current);
          }), U.cancel(p.current.update));
        };
      }), Y(P, []), ee(function () {
        return function () {
          var s = p.current;
          V(s.deps, function (S) {
            return E(S, s);
          });
        };
      });
      var $ = t.getComponentProps(m.getValue());
      return O.createElement(e, _objectSpread(_objectSpread({}, $), {}, {
        ref: o
      }));
    });
  },
  b = /*#__PURE__*/function () {
    function b(t, r) {
      _classCallCheck(this, b);
      this.update = t;
      this.deps = r;
    }
    _createClass(b, [{
      key: "eventObserved",
      value: function eventObserved(t) {
        t.type == "change" && U.write(this.update);
      }
    }]);
    return b;
  }();
function ne(e, t) {
  var r = new Set();
  return f.dependencies = r, e.style && (e = _objectSpread(_objectSpread({}, e), {}, {
    style: t.createAnimatedStyle(e.style)
  })), e = new u(e), f.dependencies = null, [e, r];
}
function ae(e, t) {
  return e && (N.fun(e) ? e(t) : e.current = t), t;
}
var j = Symbol.for("AnimatedComponent"),
  Ke = function Ke(e) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$applyAnimatedVal = _ref.applyAnimatedValues,
      t = _ref$applyAnimatedVal === void 0 ? function () {
        return !1;
      } : _ref$applyAnimatedVal,
      _ref$createAnimatedSt = _ref.createAnimatedStyle,
      r = _ref$createAnimatedSt === void 0 ? function (a) {
        return new u(a);
      } : _ref$createAnimatedSt,
      _ref$getComponentProp = _ref.getComponentProps,
      n = _ref$getComponentProp === void 0 ? function (a) {
        return a;
      } : _ref$getComponentProp;
    var a = {
        applyAnimatedValues: t,
        createAnimatedStyle: r,
        getComponentProps: n
      },
      i = function i(o) {
        var m = I(o) || "Anonymous";
        return g.str(o) ? o = i[o] || (i[o] = x(o, a)) : o = o[j] || (o[j] = x(o, a)), o.displayName = "Animated(".concat(m, ")"), o;
      };
    return oe(e, function (o, m) {
      g.arr(e) && (m = I(o)), i[m] = i(o);
    }), {
      animated: i
    };
  },
  I = function I(e) {
    return g.str(e) ? e : e && g.str(e.displayName) ? e.displayName : g.fun(e) && e.name || null;
  };
export { c as Animated, y as AnimatedArray, u as AnimatedObject, d as AnimatedString, l as AnimatedValue, Ke as createHost, k as getAnimated, Le as getAnimatedType, F as getPayload, v as isAnimated, D as setAnimated };